module.exports = __webpack_public_path__ + "ipetbooking/admin/img/dollar-sign.8fc7d662.svg";